import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			rootBtnLoyalty: {
				padding: "10px 16px 0px"
			},
			btnLoyalty: {
				cursor: "pointer",
				"& >img": {
					width: "100%",
					borderRadius: 6
				},
				"&:active": {
					opacity: 0.7,
					transition: "width 2s, height 4s",
					transitionTimingFunction: "ease-out"
				}
			}
		}),
	{
		name: "LoyaltyCRM",
		index: 1
	}
);

export default useStyles;
